// 门禁预约-访客审核
<template>
  <div class="RKEAppointmentCheck">
    <p class="title" v-if="vstatus == 0 || vstatus == 2">有{{vList.length}}位访客希望访问您</p>
    <p class="title" v-else>以下访客已经过您的审核操作</p>

    <ul class="list-wrapper">
      <li class="list" v-for="(item, index) in vList" :key="item.id">
        <p class="tit">访客{{index+1}}</p>
        <div class="info">
          <img class="img" :src="item.vphoto" alt="访客">
          <div class="right">
            <p class="name">{{item.vname}}</p>
            <p class="text"><span class="icon ico ico-phone"></span>{{item.vphone}}</p>
            <p class="text"><span class="icon ico ico-idCard"></span>{{item.vcard}}</p>
            <p class="text"><span class="icon el-icon-time"></span>{{item.start_time}} ~ {{item.end_time}}</p>
          </div>
        </div>
        <p class="vstatus" v-if="(item.vstatus == 2 && user_type == 'auditor') || item.vstatus == 1 || item.vstatus == -1 ">状态：{{item.vstatus == 1 ? '人脸验证通过' : item.vstatus == -1 ? '不通过，' + item.contents : item.vstatus == 2 ? '您已同意预约，等待被访者审核' : ''}}</p>
        <!-- <p class="desc">拒绝原因：{{item.desc}}</p> -->
      </li>
    </ul>
    <div class="bottom" v-if="vstatus == 0 || (vstatus == 2 && user_type == 'visitor')">
      <span class="btn" @click="updateAppintmentStatus(-1)">拒绝</span>
      <span class="btn" @click="updateAppintmentStatus(1)">同意</span>
    </div>
  </div>
</template>

<script>
  import { RKEApi } from "../../../../static/js/phone/phoneApi.js"
  import { vconfirm, vshowSuccess, vNotify } from "../../../../static/js/phone/utility.js"
  import { showLoading, hideLoading } from "../../../../static/js/utility/utility.js"
  import * as wx from "../../../../static/js/phone/jweixin-1.3.2.js"
  let vm 

  export default {
    name:'RKEAppointmentCheck',
    data(){
      return {
        isMiniprogram: false, // 是否在小程序环境中

        vList: [],
        vstatus: '9999',
        user_type: '' //user_type  auditor审核  visitor被访
      }
    },
    components:{
    },
    created(){
      // console.log('tag', this.$route)
      vm = this
      vm.judgeIsMini()
    },
    mounted(){
      vm.getAppointmentnInfo()
    },
    methods:{
      // 判断所处环境是否在小程序中
      judgeIsMini () {
        wx.miniProgram.getEnv(function(res) {
          vm.isMiniprogram  = res.miniprogram
        })
      },
      // 获取访客信息
      async getAppointmentnInfo () {
        let data = vm.$route.params

        showLoading('正在获取访客信息')
        let res = await RKEApi.getAppointmentnInfo(data)
        hideLoading()
        if (res.meta.code == 200) {
          vm.vList = [...res.data.list]
          vm.vstatus = [...res.data.list][0].vstatus
          vm.user_type = res.data.user_type
        } else {
          vNotify(res.meta.message)
        }
      },
      // 授权提交
      updateAppintmentStatus (status) {
        let data = vm.$route.params
        data.status = status
        let msg = '确认' + (status == 1 ? '同意' : '拒绝') +'该申请？'
        vconfirm(msg).then(function () {
          showLoading('正在提交')
          RKEApi.updateAppintmentStatus(data).then(function (res) {
            hideLoading()
            if (res.meta.code == 200) {
              vm.successOperation(status)
            } else {
              vNotify(res.meta.message)
            }
          })
        }).catch(function () {
          // console.log('取消', '')
        })
      },
      // 操作成功分场景操作（小程序端和网页端）
      successOperation (status) {
        if (vm.isMiniprogram) {
          vshowSuccess((status == 1 ? '同意' : '拒绝') + '申请成功')
          setTimeout(() => {
            wx.miniProgram.navigateBack({ delta: 1 })
          }, 1000)
        } else {
          vm.$router.push({path: '/PhonePage/AppointmentInform/Check'})
        }
      }
    },
    watch:{
    }
  }
</script>

<style lang="scss">
  .van-notify {
    line-height: 0.56rem;
    padding: 0;
    font-size: 12px;
  }
  .RKEAppointmentCheck {
    width: 100%;
    min-height: 100vh;
    background-color: #F0F2F2;
    padding-bottom: 0.92rem;
    .title {
      width: 100%;
      height: 0.56rem;
      line-height: 0.56rem;
      font-size: 0.2rem;
      color: #888888;
      text-indent: 0.2rem;
      background-color: #f0f2f2;
    }
    .list-wrapper {
      width: 100%;
      padding: 0 0.2rem;
      background-color: #ffffff;
      .list:last-child {
        border-bottom: none;
      }
      .list {
        padding-bottom: 0.15rem;
        border-bottom: solid 1px #f3f3f3;
        .tit {
          height: 0.7rem;
          line-height: 0.7rem;
          font-size: 0.24rem;
          color: #ffb400;
        }
        .info {
          display: flex;
          .img {
            width: 1.46rem;
            height: 1.46rem;
            margin-right: 0.53rem;
            border-radius: 0.1rem;
            clip: rect(0px,0px,0px,0px);
          }
          .right {
            font-size: 0.14rem;
            line-height: 0.37rem;
            .name {
              font-size: 0.28rem;
              line-height: 0.3rem;
              margin-bottom: 0.09rem;
            }
            .icon {
              font-size: 0.22rem;
              margin-right: 0.1rem;
            }
            .text {
              display: flex;
              align-items: center;
            }
          }
        }
        .vstatus {
          margin-top: 0.2rem;
        }
        .desc,.vstatus{
          font-size: 0.22rem;
          line-height: 0.34rem;
          color: #333333;
        }
      }
    }
    .bottom {
    width: 100%;
    height: 0.7rem;
    text-align: center;
    font-size: 0.3rem;
    color: #ffffff;
    background-color: #2d83f4;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    .btn {
      flex: 1;
      opacity: 0.6;
    }
  }
  .bottom:before {
    display: block;
    content: '';
    width: 1px;
    height: 0.6rem;
    background-color: #57bcee;
    position: absolute;
    left: 0 ;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  }
</style>


// WEBPACK FOOTER //
// src/components/PhonePage/RKEAppointment/AppointmentCheck.vue